const LanguageKey = 'adminLanguageMode'

const dictionary = {
  '欢迎': 'Welcome',
  '登录': 'Login',
  '首页': 'Home',
  '活动 Code': 'Activity Code',
  '暂无': 'None',
  '复制': 'Copy',
  '活动名称': 'Activity Name',
  '核验密码修改': 'Verification Password',
  '修改': 'Edit',
  '语言模式': 'Language',
  '中文': 'Chinese',
  '活动状态': 'Activity Status',
  '活动进行中': 'Active',
  '活动已暂停': 'Paused',
  '暂停活动': 'Pause Activity',
  '开始活动': 'Start Activity',
  '奖项管理': 'Prize Management',
  '中奖记录': 'Winning Records',
  '请选择或输入': 'Please select or enter',
  '填写物流': 'Fill Logistics',
  '修改物流': 'Edit Logistics',
  '填写物流信息': 'Fill Logistics Info',
  '物流公司名称': 'Logistics Company',
  '请输入物流公司名称': 'Please enter logistics company',
  '物流单号': 'Tracking Number',
  '请输入物流单号': 'Please enter tracking number',
  '物流信息提交成功': 'Logistics info submitted successfully',
  '物流信息提交失败': 'Failed to submit logistics info',
  '暂无快递信息': 'No delivery info',
  '获取快递信息失败': 'Failed to get delivery info',
  '核销状态更新成功': 'Verification status updated successfully',
  '核销状态更新失败': 'Failed to update verification status',
  '网络错误，请重试': 'Network error, please try again',
  '确定要删除这条中奖记录吗？': 'Are you sure you want to delete this winning record?',
  'IP地址': 'IP Address',
  'IP地址：': 'IP Address:',
  '收货人': 'Recipient',
  '收货人：': 'Recipient:',
  '电话': 'Phone',
  '电话：': 'Phone:',
  '地址': 'Address',
  '地址：': 'Address:',
  '邮编': 'Postal Code',
  '兑换码管理': 'Redeem Code Management',
  '一键删除中奖记录': 'Delete Winning Records',
  '一键删除参与用户记录': 'Delete Participant Records',
  '一键开奖': 'Draw Now',
  '主账号': 'Main Account',
  '子账号': 'Sub Account',
  '管理员': 'Admin',
  '主账号手机号': 'Main Account Phone',
  '默认大转盘配置': 'Default Wheel Configuration',
  '显示客服按钮': 'Show Customer Service Button',
  '显示': 'Show',
  '隐藏': 'Hide',
  '自定义标签': 'Custom Label',
  '请输入自定义标签，如：手机、联系电话等': 'Please enter custom label, e.g. Phone, Contact Phone',
  '确定': 'Confirm',
  '客服图片': 'Customer Service Image',
  '修改核验密码': 'Change Verification Password',
  '新核验密码': 'New Verification Password',
  '请输入新核验密码': 'Please enter new verification password',
  '确认密码': 'Confirm Password',
  '请再次输入核验密码': 'Please enter verification password again',
  '取消': 'Cancel',
  '账号': 'Account',
  '密码': 'Password',
  '用户名': 'Username',
  '手机号': 'Phone',
  '手机号码': 'Phone Number',
  '姓名': 'Name',
  '活动说明': 'Activity Description',
  '请输入账号': 'Please enter account',
  '请输入密码': 'Please enter password',
  '请输入活动说明': 'Please enter activity description',
  '请输入用户名': 'Please enter username',
  '请输入手机号': 'Please enter phone number',
  '请输入姓名': 'Please enter name',
  '请输入': 'Please enter',
  '请选择': 'Please select',
  '保存': 'Save',
  '新增': 'Add',
  '编辑': 'Edit',
  '删除': 'Delete',
  '查询': 'Search',
  '重置': 'Reset',
  '操作': 'Actions',
  '状态': 'Status',
  '时间': 'Time',
  '创建时间': 'Created At',
  '更新时间': 'Updated At',
  '开始时间': 'Start Time',
  '结束时间': 'End Time',
  '中奖时间': 'Winning Time',
  '中奖奖品': 'Prize Won',
  '奖项管理': 'Prize Management',
  '新增奖项': 'Add Prize',
  '编辑奖项': 'Edit Prize',
  '奖项名称': 'Prize Name',
  '请输入奖项名称': 'Please enter prize name',
  '奖品名称': 'Prize Name',
  '奖品名称：': 'Prize Name:',
  '奖品图片': 'Prize Image',
  '中奖概率': 'Winning Probability',
  '中奖概率(%)': 'Winning Probability (%)',
  '请输入中奖概率': 'Please enter winning probability',
  '奖品总库存': 'Total Stock',
  '奖品剩余库存': 'Remaining Stock',
  '总库存': 'Total Stock',
  '剩余库存': 'Remaining Stock',
  '奖品数量': 'Prize Quantity',
  '请输入奖品数量': 'Please enter prize quantity',
  '奖品描述': 'Prize Description',
  '请输入奖品描述': 'Please enter prize description',
  '奖品图片：': 'Prize Image:',
  '中奖概率：': 'Winning Probability:',
  '总库存：': 'Total Stock:',
  '剩余库存：': 'Remaining Stock:',
  '描述：': 'Description:',
  '描述': 'Description',
  '是否需要兑奖': 'Require Redemption',
  '需要兑奖': 'Requires Redemption',
  '不需要兑奖': 'No Redemption Required',
  '建议尺寸：200x200px': 'Recommended size: 200x200px',
  '确定要删除该奖项吗？': 'Are you sure you want to delete this prize?',
  '操作失败': 'Operation failed',
  '编辑成功': 'Updated successfully',
  '库存': 'Stock',
  '中奖人数': 'Winner Count',
  '参与人数': 'Participant Count',
  '兑换码': 'Redeem Code',
  '兑换码：': 'Redeem Code:',
  '核销状态': 'Verification Status',
  '核销状态：': 'Verification Status:',
  '核销人员': 'Verifier',
  '核销人员：': 'Verifier:',
  '快递信息': 'Delivery Info',
  '快递信息：': 'Delivery Info:',
  '物流操作': 'Delivery Actions',
  '物流操作：': 'Delivery Actions:',
  '活动规则': 'Activity Rules',
  '问卷管理': 'Questionnaire Management',
  '问卷记录': 'Questionnaire Records',
  '用户管理': 'User Management',
  '用户参与': 'User Participation',
  '导出记录': 'Export Records',
  '搜索': 'Search',
  '查看头像': 'View Avatar',
  '微信昵称': 'WeChat Nickname',
  '微信昵称：': 'WeChat Nickname:',
  '微信头像': 'WeChat Avatar',
  '微信头像：': 'WeChat Avatar:',
  '设备码': 'Device Code',
  '设备码：': 'Device Code:',
  '注册IP': 'Registration IP',
  '注册IP：': 'Registration IP:',
  '注册时间': 'Registration Time',
  '注册时间：': 'Registration Time:',
  '手机号：': 'Phone:',
  '用户名：': 'Username:',
  '确定要删除该用户吗？': 'Are you sure you want to delete this user?',
  '确定要删除该参与用户吗？': 'Are you sure you want to delete this participant?',
  '导出成功': 'Export successful',
  '导出失败': 'Export failed',
  '管理员管理': 'Admin Management',
  '系统设置': 'System Settings',
  '内定手机': 'Fixed Phones',
  '内定手机号码管理': 'Fixed Phone Number Management',
  '添加内定手机号码': 'Add Fixed Phone Number',
  '内定手机号码列表': 'Fixed Phone Number List',
  '内定奖项': 'Fixed Prize',
  '请输入内定的手机号码': 'Please enter the fixed phone number',
  '请选择内定奖项': 'Please select a fixed prize',
  '暂无内定手机号码': 'No fixed phone numbers',
  '获取内定手机号码列表失败': 'Failed to get fixed phone number list',
  '获取奖项列表失败': 'Failed to get prize list',
  '请选择有效的奖项': 'Please select a valid prize',
  '添加内定手机号码成功': 'Fixed phone number added successfully',
  '添加内定手机号码失败': 'Failed to add fixed phone number',
  '删除内定手机号码成功': 'Fixed phone number deleted successfully',
  '删除内定手机号码失败': 'Failed to delete fixed phone number',
  '请输入手机号码': 'Please enter phone number',
  '请输入正确的手机号码': 'Please enter a valid phone number',
  '手机号码': 'Phone Number',
  '概率': 'Probability',
  '序号': 'No.',
  '商品管理': 'Product Management',
  '积分商城用户管理': 'Mall User Management',
  '用户兑换记录': 'Exchange Records',
  '请填写完整信息': 'Please complete all required information',
  '已取消删除': 'Deletion canceled',
  '提示': 'Notice',
  '参与人员限制': 'Participant Limit',
  '单个新增': 'Add Single',
  '批量新增': 'Batch Add',
  '批量删除': 'Batch Delete',
  '批量导入': 'Batch Import',
  '请输入批量导入内容': 'Please enter batch import content',
  '未解析到有效数据，请检查格式': 'No valid data parsed. Please check the format',
  '批量新增成功': 'Batch add successful',
  '批量新增失败': 'Batch add failed',
  '批量删除成功': 'Batch delete successful',
  '批量删除失败': 'Batch delete failed',
  '确定要删除选中的记录吗？': 'Are you sure you want to delete the selected records?',
  '请按照以下格式输入：\n姓名 手机号码\n姓名 手机号码\n例如：\n张三 13800138000\n李四 13800138001': 'Please enter in the following format:\nName Phone Number\nName Phone Number\nExample:\nJohn 13800138000\nTom 13800138001',
  '清除测试数据': 'Clear Test Data',
  '点击按钮将清除活动数据(参与人员记录 中奖记录 恢复奖品库存),需谨慎操作': 'Click the button to clear activity data (participant records, winning records, and restore prize stock). Please operate carefully.',
  '当前活动编码': 'Current Activity Code',
  '清除活动数据': 'Clear Activity Data',
  '未获取到活动编码': 'Activity code was not found',
  '⚠活动数据将清除,确定要清除吗?': '⚠ Activity data will be cleared. Are you sure?',
  '清除成功': 'Cleared successfully',
  '清除失败': 'Clear failed',
  '成功': 'Success',
  '失败': 'Failed',
  '上传成功': 'Upload successful',
  '上传失败': 'Upload failed',
  '保存成功': 'Saved successfully',
  '保存失败': 'Save failed',
  '新增成功': 'Added successfully',
  '新增失败': 'Add failed',
  '修改成功': 'Updated successfully',
  '修改失败': 'Update failed',
  '删除成功': 'Deleted successfully',
  '删除失败': 'Delete failed',
  '复制失败，请手动复制': 'Copy failed, please copy manually',
  '活动 Code 已复制到剪贴板': 'Activity Code copied to clipboard',
  '核验密码修改成功': 'Verification password updated successfully',
  '两次输入的密码不一致': 'The two passwords do not match',
  '长度在 3 到 20 个字符': 'Length must be between 3 and 20 characters',
  '长度在 6 到 20 个字符': 'Length must be between 6 and 20 characters',
  '请输入正确的手机号': 'Please enter a valid phone number',
  '请输入新密码': 'Please enter new password',
  '请确认密码': 'Please confirm password',
  '密码长度不能少于6位': 'Password must be at least 6 characters',
  '请输入自定义标签': 'Please enter custom label',
  '自定义标签保存成功': 'Custom label saved successfully',
  '已开启客服按钮显示': 'Customer service button is shown',
  '已关闭客服按钮显示': 'Customer service button is hidden',
  '客服图片上传成功': 'Customer service image uploaded successfully',
  '上传图片只能是 JPG/PNG 格式!': 'Only JPG/PNG images are allowed!',
  '上传图片大小不能超过 5MB!': 'Image size cannot exceed 5MB!',
  '确定要删除所有中奖记录吗？此操作不可恢复！': 'Are you sure you want to delete all winning records? This action cannot be undone!',
  '确定要删除所有参与用户记录吗？此操作不可恢复！': 'Are you sure you want to delete all participant records? This action cannot be undone!',
  '警告': 'Warning',
  '成功清空所有中奖记录': 'All winning records cleared successfully',
  '清空中奖记录失败': 'Failed to clear winning records',
  '成功清空所有参与用户记录': 'All participant records cleared successfully',
  '清空参与用户记录失败': 'Failed to clear participant records',
  '确定要进行开奖吗？': 'Are you sure you want to draw?',
  '确认开奖': 'Confirm Draw',
  '开奖失败': 'Draw failed',
  '开奖失败，请稍后重试': 'Draw failed, please try again later',
  '自动开奖完成': 'Auto draw completed',
  '当前活动无活动编码，无法开奖': 'Current activity has no activity code and cannot draw',
  '目前活动正在进行中，确定要暂停吗？': 'The activity is currently active. Are you sure you want to pause it?',
  '确认暂停': 'Confirm Pause',
  '活动已开始': 'Activity started',
  '活动已暂停': 'Activity paused',
  '开始活动失败': 'Failed to start activity',
  '暂停活动失败': 'Failed to pause activity',
  '开始活动失败，请稍后重试': 'Failed to start activity, please try again later',
  '暂停活动失败，请稍后重试': 'Failed to pause activity, please try again later',
  '管理员ID不存在': 'Admin ID does not exist',
  '程序出错': 'Program Error',
  '请联系管理员': 'Please contact the administrator',
  '编辑管理员': 'Edit Admin',
  '新增管理员': 'Add Admin',
  '用此模板': 'Use This Template',
  '用此模板新增子账号': 'Add Sub Account From Template',
  '活动 Code 已复制到剪贴板': 'Activity Code copied to clipboard',
  '是否国外': 'Foreign Version',
  '是否有头像': 'Show Avatar',
  '是否测试': 'Test Mode',
  '是否有广告': 'Has Ads',
  '是否隐藏活动规则': 'Hide Activity Rules',
  '是否隐藏举报按钮': 'Hide Report Button',
  '是否可以分享小程序': 'Allow Share Mini Program',
  '是否需要姓名': 'Require Name',
  '是否需要手机号': 'Require Phone',
  '是否使用兑换码': 'Use Redeem Code',
  '是否需要核销': 'Require Verification',
  '是否需要填写快递信息': 'Require Delivery Info',
  '核验密码': 'Verification Password',
  '参与次数限制类型': 'Participation Limit Type',
  '参与次数限制': 'Participation Limit',
  '使用时间范围': 'Available Time Range',
  '一键设置一年时间': 'Set One Year',
  '一键设置三天时间': 'Set Three Days',
  '添加自定义字段': 'Add Custom Field',
  '自定义字段': 'Custom Field',
  '字段': 'Field',
  '输入框': 'Input',
  '上传图片': 'Upload Image',
  '抽奖类型': 'Lottery Type',
  '大转盘': 'Wheel',
  '福袋': 'Lucky Bag',
  '砸金蛋': 'Golden Egg',
  '九宫格': 'Grid',
  '翻牌': 'Flip Card',
  '抽号码': 'Number Draw',
  '刮刮乐': 'Scratch Card',
  '扭蛋机': 'Capsule Machine',
  '自动开奖': 'Auto Draw',
  '大屏': 'Big Screen',
  '奖品图片透明度': 'Prize Image Opacity',
  '大转盘图片': 'Wheel Image',
  '大转盘背景图': 'Wheel Background',
  '福袋背景图': 'Lucky Bag Background',
  '砸金蛋背景图': 'Golden Egg Background',
  '九宫格背景图': 'Grid Background',
  '翻牌背景图': 'Flip Card Background',
  '抽号码背景图': 'Number Draw Background',
  '刮刮乐背景图': 'Scratch Card Background',
  '扭蛋机背景图': 'Capsule Machine Background',
  '自动开奖背景图': 'Auto Draw Background',
  '自动开奖奖品文字颜色': 'Auto Draw Prize Text Color',
  '自动开奖活动信息文字颜色': 'Auto Draw Activity Info Text Color',
  '大屏手机端报名背景图': 'Mobile Signup Background',
  '开奖时间': 'Draw Time',
  '活动规则图': 'Activity Rules Image',
  '中奖结果弹窗背景图': 'Winning Result Popup Background',
  '中奖结果弹窗关闭按钮': 'Winning Result Close Button',
  '填写信息窗口图片定部': 'Signup Popup Top Image',
  '填写信息窗口背景色': 'Signup Popup Background Color',
  '填写信息输入框线条颜色': 'Signup Input Border Color',
  '填写信息窗口图片底部': 'Signup Popup Bottom Image',
  '填写信息窗口关闭按钮图片': 'Signup Popup Close Button Image',
  '整体背景图片': 'Overall Background Image',
  '奖项图片宽度': 'Prize Image Width',
  '中心按钮图片': 'Center Button Image',
  '中心按钮尺寸': 'Center Button Size',
  '福袋图片': 'Lucky Bag Image',
  '金蛋完整图片': 'Golden Egg Image',
  '金蛋砸开图片': 'Cracked Egg Image',
  '卡牌正面': 'Card Front',
  '卡牌背面': 'Card Back',
  '卡牌文字颜色': 'Card Text Color',
  '九宫格框背景图片': 'Grid Frame Background',
  '九宫格框开始按钮': 'Grid Start Button',
  '九宫格奖项文字颜色': 'Grid Prize Text Color',
  '九宫格背景色': 'Grid Background Color',
  '九宫格active背景色': 'Grid Active Background Color',
  '右侧按钮margintop': 'Right Button Margin Top',
  '按钮盒子top值': 'Button Box Top',
  '活动时间margin-top值': 'Activity Time Margin Top',
  '我的奖品margin-top值': 'My Prize Margin Top',
  '非默认大转盘颜色1': 'Custom Wheel Color 1',
  '非默认大转盘颜色2': 'Custom Wheel Color 2',
  '大转盘阴影颜色': 'Wheel Shadow Color',
  '大转盘文字颜色': 'Wheel Text Color',
  '转盘大小': 'Wheel Size',
  '我的奖品页背景图': 'My Prize Page Background',
  '我的奖品按钮图片': 'My Prize Button Image',
  '活动时间文字颜色': 'Activity Time Text Color',
  '按钮文字颜色': 'Button Text Color',
  '我的奖品文字颜色': 'My Prize Text Color',
  '剩余次数背景图': 'Remaining Count Background',
  '剩余次数背景颜色': 'Remaining Count Background Color',
  '剩余次数文字颜色': 'Remaining Count Text Color',
  '去邀请按钮背景颜色': 'Invite Button Background Color',
  '去邀请按钮文字颜色': 'Invite Button Text Color',
  '抽奖背景音乐': 'Lottery Background Music',
  '是否邀请获得抽奖次数': 'Invite To Get Lottery Count',
  '转发次数得抽奖机会': 'Share Count To Lottery',
  '是否隐藏中奖名单': 'Hide Winner List',
  '是否需要问卷': 'Require Questionnaire',
  '是否需要分数': 'Require Score',
  '答题所需最低分数': 'Minimum Score',
  '答题后是否立刻显示答案': 'Show Answer Immediately',
  '问卷背景图': 'Questionnaire Background',
  '一等奖': 'First Prize',
  '二等奖': 'Second Prize',
  '三等奖': 'Third Prize',
  '未中奖': 'Not Winning',
  '已中奖': 'Won',
  '已核销': 'Verified',
  '未核销': 'Unverified',
  '已使用': 'Used',
  '未使用': 'Unused',
  '启用': 'Enable',
  '禁用': 'Disable',
  '详情': 'Details',
  '导出': 'Export',
  '上传': 'Upload',
  '下载': 'Download',
  '刷新': 'Refresh',
  '返回': 'Back',
  '关闭': 'Close',
  '上一页': 'Previous',
  '下一页': 'Next',
  '共': 'Total',
  '前往': 'Go to',
  '条/页': '/ page',
  '总计': 'Total',
  '条': 'items',
  '第': 'No.',
  '页': 'Page',
  '是': 'Yes',
  '否': 'No'
}

const originalTextMap = new WeakMap()
const originalAttrMap = new WeakMap()
let observer = null
let translateTimer = null
let isTranslatingPage = false

export function getLanguageMode() {
  return localStorage.getItem(LanguageKey) || 'zh'
}

export function setLanguageMode(language) {
  localStorage.setItem(LanguageKey, language === 'en' ? 'en' : 'zh')
  window.dispatchEvent(new CustomEvent('admin-language-change'))
}

export function isEnglish() {
  return getLanguageMode() === 'en'
}

export function t(text) {
  if (!isEnglish() || typeof text !== 'string') return text
  return translateText(text)
}

function translateText(text) {
  if (!text) return text
  const trimmed = text.trim()
  if (!trimmed) return text
  if (dictionary[trimmed]) {
    return text.replace(trimmed, dictionary[trimmed])
  }
  let result = text
  Object.keys(dictionary)
    .sort((a, b) => b.length - a.length)
    .forEach(key => {
      result = result.split(key).join(dictionary[key])
    })
  return /[\u4e00-\u9fa5]/.test(result) ? text : result
}

function translateAttributes(el) {
  const attrs = ['placeholder', 'title', 'aria-label']
  attrs.forEach(attr => {
    if (!el.hasAttribute || !el.hasAttribute(attr)) return
    let attrMap = originalAttrMap.get(el)
    if (!attrMap) {
      attrMap = {}
      originalAttrMap.set(el, attrMap)
    }
    if (!attrMap[attr]) attrMap[attr] = el.getAttribute(attr)
    el.setAttribute(attr, isEnglish() ? translateText(attrMap[attr]) : attrMap[attr])
  })
}

function shouldSkipTranslateElement(el) {
  return el && el.closest && el.closest('.el-pagination')
}

function translateNode(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    if (shouldSkipTranslateElement(node.parentElement)) return
    const value = node.nodeValue

    if (originalTextMap.has(node)) {
      const original = originalTextMap.get(node)
      const translatedOriginal = translateText(original)
      if (value !== original && value !== translatedOriginal) {
        originalTextMap.set(node, value)
        node.nodeValue = isEnglish() ? translateText(value) : value
      } else {
        node.nodeValue = isEnglish() ? translatedOriginal : original
      }
      return
    }

    if (!value || !/[\u4e00-\u9fa5]/.test(value)) return
    originalTextMap.set(node, value)
    node.nodeValue = isEnglish() ? translateText(value) : value
    return
  }

  if (node.nodeType !== Node.ELEMENT_NODE) return
  if (shouldSkipTranslateElement(node)) return
  const tagName = node.tagName
  if (tagName === 'SCRIPT' || tagName === 'STYLE') return
  translateAttributes(node)
  Array.from(node.childNodes || []).forEach(translateNode)
}

export function translatePage() {
  if (!document.body || isTranslatingPage) return
  isTranslatingPage = true
  try {
    translateNode(document.body)
  } finally {
    isTranslatingPage = false
  }
}

export function scheduleTranslate() {
  if (isTranslatingPage) return
  clearTimeout(translateTimer)
  translateTimer = setTimeout(translatePage, 0)
}

function wrapMessage(Vue) {
  const message = Vue.prototype.$message
  if (!message || message.__i18nWrapped) return

  const wrapOptions = options => {
    if (typeof options === 'string') return t(options)
    if (options && typeof options === 'object' && typeof options.message === 'string') {
      return { ...options, message: t(options.message) }
    }
    return options
  }

  const wrapped = options => message(wrapOptions(options))
  ;['success', 'warning', 'info', 'error'].forEach(type => {
    wrapped[type] = options => message[type](wrapOptions(options))
  })
  wrapped.closeAll = message.closeAll
  wrapped.__i18nWrapped = true
  Vue.prototype.$message = wrapped
}

function wrapConfirm(Vue) {
  const confirm = Vue.prototype.$confirm
  if (!confirm || confirm.__i18nWrapped) return

  const wrapped = function(message, title, options) {
    const newOptions = options ? { ...options } : undefined
    if (newOptions) {
      if (newOptions.confirmButtonText) newOptions.confirmButtonText = t(newOptions.confirmButtonText)
      if (newOptions.cancelButtonText) newOptions.cancelButtonText = t(newOptions.cancelButtonText)
    }
    return confirm.call(this, t(message), t(title), newOptions)
  }
  wrapped.__i18nWrapped = true
  Vue.prototype.$confirm = wrapped
}

export function installI18n(Vue) {
  Vue.prototype.$tText = t
  Vue.prototype.$setLanguageMode = setLanguageMode
  wrapMessage(Vue)
  wrapConfirm(Vue)

  Vue.mixin({
    mounted() {
      scheduleTranslate()
    },
    updated() {
      scheduleTranslate()
    }
  })

  window.addEventListener('admin-language-change', scheduleTranslate)
  if (!observer) {
    observer = new MutationObserver(mutations => {
      if (isTranslatingPage) return
      const hasAddedNodes = mutations.some(mutation => mutation.addedNodes && mutation.addedNodes.length > 0)
      if (hasAddedNodes) scheduleTranslate()
    })
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    })
  }
  scheduleTranslate()
}
